import { queryOptions, useQuery } from '@tanstack/react-query';
import { QueryConfig } from '@nohara/react-core';
import { OrgEntity, ApiResponse } from '@nohara/oidc-core';

import { api } from '@/lib';

export const getUserOrgs = async (userId: string): Promise<OrgEntity[]> => {
  const { data } = await api.get<any, ApiResponse<OrgEntity[]>>(`/users/${userId}/orgs`);
  return data;
};

export const getUserOrgsQueryOptions = (userId: string | undefined | null) => {
  return queryOptions({
    queryKey: ['user-orgs', userId],
    queryFn: () => getUserOrgs(userId!),
    enabled: !!userId,
  });
};

type UseUserOrgsOptions = {
  queryConfig?: QueryConfig<typeof getUserOrgsQueryOptions>;
};

export const useUserOrgs = (
  userId: string | undefined,
  { queryConfig }: UseUserOrgsOptions = {}
) => {
  return useQuery({
    ...getUserOrgsQueryOptions(userId),
    ...queryConfig,
  });
};
